import {Alert} from 'platform/components';
import {Box} from 'platform/foundation';

import {useSelector} from 'react-redux';

import i18n from '@dms/i18n';
import {usePermissions} from '@dms/shared';

import {selectAudit, selectAuditState} from '../../../store/carAudit/selectors';

export function ToFinishingComment() {
  const audit = useSelector(selectAudit);
  const auditState = useSelector(selectAuditState);

  const [hasCloseInspectionPermission, hasUpdateInspectionPermission] = usePermissions({
    permissionKeys: ['closeInspection', 'updateInspection'],
    scopes: {
      closeInspection: {
        inspectionType: audit?.inspectionType,
        // Gated by inspection type, not participation
        participation: 'SKIP',
      },
      updateInspection: {
        inspectionType: audit?.inspectionType,
        inspectionState: audit?.state,
        // Gated by inspection type/state, not participation
        participation: 'SKIP',
      },
    },
  });

  const auditToFinishingNote = audit?.inspectionNote;

  if (
    !audit ||
    !auditState ||
    !auditToFinishingNote ||
    !hasCloseInspectionPermission ||
    !hasUpdateInspectionPermission
  ) {
    return null;
  }

  return (
    <Box paddingBottom={4}>
      <Alert
        type="inline"
        title={i18n.t('entity.inspection.notifications.toFinishing.title')}
        message={auditToFinishingNote}
      />
    </Box>
  );
}
